module.exports = __webpack_public_path__ + "static/media/Makeup01.5eef95bd.jpeg";